<template>
    <div class="form-group" data-id="form-textarea" v-bind:class="[{ 'has-messaging': uiStates.message }, 'has-'+uiStates.messageClass+'-message']">
        <div class="input-group">
            <div v-if="typeof field.prepend !== 'undefined' && field.prepend.enabled == true" class="input-group-prepend" data-id="textarea-prepend">
                <span class="input-group-text">
                    <span data-id="textarea-prepend-value" v-html="field.prepend.value"></span>
                </span>
            </div>
            <textarea :disabled="field.disabled" v-model="field.value" :name="field.name" :required="field.required ? true : false" class="form-control" cols="30" rows="4" data-id="textarea" ></textarea>
            <div v-if="typeof field.append !== 'undefined' && field.append.enabled == true" class="input-group-append" data-id="textarea-append-enabled">
                <span class="input-group-text">
                    <span data-id="textarea-append" v-html="field.append.value"></span>
                </span>
            </div>
        </div>
        <small v-if="(this.activeLanguage !== 0) && (typeof masterValue !== 'undefined')" class="form-text text-muted">Master Value: {{ masterValue }}</small>
        <ul v-if="uiStates.message" class="message-listing">
            <li>{{uiStates.message}}</li>
        </ul>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import select2 from 'select2';

    Vue.use(VueEvents)

    export default {
        name: 'form-input-textarea',
        props: ['FieldData', 'masterValue', 'activeLanguage'],
        components:{
        },
        data() {
            return {
                uiStates: {
                    message:"",
                    messageClass:"",
                },
                field: this.FieldData,
            }
        },
        mounted() {
            this.$emit('input', this.field.value);
        },
        created() {

        },
        watch: {

        },
        methods: {

        }
    };
</script>

<style scoped lang="scss">
    .required-field{
        font-size: 16px;
        color: #AB5755;
        position: absolute;
        top: -4px;
    }
    label{
        position: relative;
    }
</style>